import React from 'react';
import { Link } from 'react-router-dom';
import PageTemplate from '../components/PageTemplate';

const Industries = () => {
  return (
    <PageTemplate
      title="Industry Solutions"
      subtitle="Specialized technology solutions tailored for your industry"
      breadcrumb="Industries"
    >
      <div className="content-section">
        <div className="content-grid">
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-heartbeat"></i>
            </div>
            <h4>Healthcare & Biotech</h4>
            <p>Advanced healthcare software, AI for medical imaging, and biotechnology solutions.</p>
            <Link to="/industries/healthcare" className="btn btn-outline">Healthcare Solutions</Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-credit-card"></i>
            </div>
            <h4>FinTech</h4>
            <p>Financial technology solutions including digital banking, payments, and trading platforms.</p>
            <Link to="/industries/fintech" className="btn btn-outline">FinTech Services</Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-shopping-cart"></i>
            </div>
            <h4>Retail & E-commerce</h4>
            <p>Modern retail solutions with AI-powered personalization and omnichannel experiences.</p>
            <Link to="/industries/retail" className="btn btn-outline">Retail Solutions</Link>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-store"></i>
            </div>
            <h4>E-commerce Development</h4>
            <p>Custom e-commerce platforms and marketplaces with advanced features and integrations.</p>
            <Link to="/industries/ecommerce" className="btn btn-outline">E-commerce</Link>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Industries; 